import { WEEK_DAYS } from './constants';

export const formatRemindTime = (hour: number, minute: number) => {
  const hh = hour.toString().padStart(2, '0');
  const mm = minute.toString().padStart(2, '0');
  const remindTime = `${hh}:${mm}`;
  return remindTime;
};

export const getDisplayRepeatTimes = (repeatTimes: number[]) => {
  if (repeatTimes.length === 0) {
    return '永不';
  }
  if (repeatTimes.length === 7) {
    return '每日';
  }

  const repeatTimeList: string[] = [];
  repeatTimes.forEach((number) => {
    repeatTimeList.push(WEEK_DAYS[number]);
  });

  const displayRepeatTime = repeatTimeList.join('/');
  return displayRepeatTime;
};
